/**
 * Returns the UTC date and time of one year from now.
 * It is important to keep this in UTC.
 */
export const getDefaultExpirationDate = () => {
    const expirationDate = new Date();
    expirationDate.setFullYear(expirationDate.getFullYear() + 1);
    expirationDate.setHours(0, 0, 0, 0);
    return expirationDate.toISOString();
}